import React from 'react';
import { SelectProps } from 'antd';
import { useQuery } from 'react-query';
import { getLeadFilterOptions } from '~/api/sales';
import Select from './Select';

export interface LeadFilterSelectProps extends SelectProps {
    filterCriteria: 'utmSource' | 'utmMedium' | 'campaignName' | 'adGroupName';
}

const LeadFilterSelect: React.FC<LeadFilterSelectProps> = (props) => {
    const { data, isLoading } = useQuery('leadFilterOptions', getLeadFilterOptions, {
        staleTime: 5 * 60 * 1000, // Cache for 5 minutes
    });

    // Parse the handbook structure similar to SalesFilterSelect
    const options = data?.handbooks
        ?.find((item) => item.key === props.filterCriteria)
        ?.values?.map((item) => ({
            label: item.localizedValue,
            value: item.apiValue,
            key: item.key,
        })) || [];

    return (
        <Select
            loading={isLoading}
            disabled={isLoading}
            showSearch
            options={options}
            {...props}
        />
    );
};

export default LeadFilterSelect;
